import installAlignment from '@redturtle/iovisit-theme/config/Slate/Alignment';
import installLinkButton from '@redturtle/iovisit-theme/config/Slate/LinkButton';
import tableSVG from '@plone/volto/icons/table.svg';
import ScrollableTableEdit from '@redturtle/iovisit-theme/components/ScrollableTable/ScrollableTableEdit';
import ScrollableTableView from '@redturtle/iovisit-theme/components/ScrollableTable/ScrollableTableView';

export default function install(config) {
  installAlignment(config);
  installLinkButton(config);

  const tableBlockConfig = {
    id: 'table',
    title: 'Table',
    icon: tableSVG,
    group: 'common',
    view: ScrollableTableView,
    edit: ScrollableTableEdit,
    restricted: false,
    mostUsed: false,
    blockHasOwnFocusManagement: true,
    sidebarTab: 1,
    security: {
      addPermission: [],
      view: [],
    },
    // blockHasValue: (data) => {
    //   return true;
    // },
  };

  config.blocks.blocksConfig.slateTable = {
    ...tableBlockConfig,
    id: 'slateTable',
  };

  return config;
}
